import React from 'react';
import {
  Container,
  ContainerProps,
  useMultiStyleConfig,
} from '@chakra-ui/react';
import { CenteredContainer } from 'app/components/Core';
import { config } from 'config';
import { useIsMobile } from 'app/utils/hooks';

interface ChakraAuthContentWrapperProps extends ContainerProps {
  centeredContainerProps?: ContainerProps;
}

export const ChakraAuthContentWrapper: React.FC<ChakraAuthContentWrapperProps> = ({
  children,
  centeredContainerProps,
  sx,
  ...rest
}) => {
  const isMobileView = useIsMobile(false);
  const styles = useMultiStyleConfig('AuthContentWrapper', {
    isElectronBuild: config.isElectronBuild,
    isMobile: isMobileView,
  });

  return (
    <Container
      sx={{
        ...styles.container,
        ...sx,
      }}
      {...rest}
    >
      <CenteredContainer
        {...centeredContainerProps}
        sx={{
          ...styles.centeredLayout,
          ...centeredContainerProps?.sx,
        }}
      >
        {children}
      </CenteredContainer>
    </Container>
  );
};
